"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _queryString = _interopRequireDefault(require("query-string"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _reactRouterDom = require("react-router-dom");
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../../api/ApplicationContext");
var _TokenAuthenticationStepResponse = _interopRequireDefault(require("../../api/auth/TokenAuthenticationStepResponse"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class TokenAuthenticationStep extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      errorMessage: ''
    };
  }
  componentDidMount() {
    const {
      token
    } = _queryString.default.parse(this.props.location.search);
    const cleanToken = _dompurify.default.sanitize(token);
    _ApplicationContext.ApplicationContext.setContext('originalToken', cleanToken);
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    const step = new _TokenAuthenticationStepResponse.default();
    step.token = cleanToken;
    this.props.listener(this, step);
  }
  render() {
    const {
      errorMessage
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay ${!errorMessage && 'is-active'}`
    }, !errorMessage && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), errorMessage && /*#__PURE__*/_react.default.createElement(_core.ErrorNotification, {
      status: "Authentication Error"
    }, errorMessage));
  }
}
TokenAuthenticationStep.propTypes = {
  listener: _propTypes.default.func.isRequired,
  location: _propTypes.default.shape({
    search: _propTypes.default.string
  }),
  match: _propTypes.default.shape({
    params: _propTypes.default.shape({
      token: _propTypes.default.string
    })
  })
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(TokenAuthenticationStep);
//# sourceMappingURL=TokenAuthenticationStep.js.map